// Hooks
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { useFeatures, getEnabledFeatures } from '../../hooks/features';
import { getClient } from '../../utils/getClient';

const MUTATION_PREFIX = ['RedVelvetApi', 'getAmbassador'];

export function useGetAmbassador(employeeId: string) {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useQuery({
    enabled: !!employeeId,
    queryKey: MUTATION_PREFIX.concat([employeeId ?? '']),
    queryFn: async () => {
      return await client.getAmbassadorByEmployeeId({ employeeId });
    },
  });
}
